import { SxProps } from '@mui/material'
import { actionButtonClasses } from './ActionButtons.data'

interface ActionButtonsStyles {
  wrapper: SxProps
  button: SxProps
  buttonLarge: SxProps
  buttonSecondary: SxProps
}
export const actionButtonsStyles: ActionButtonsStyles = {
  wrapper: {
    display: 'flex',
    alignItems: { xs: 'initial', sm: 'center' },
    flexDirection: { xs: 'column', lg: 'row' },
    p: { xs: 3, lg: 0 },
    gap: { xs: 1.5, lg: 1 },
    bottom: 0,
    left: 0,
    width: {
      xs: '100vw',
      lg: '100%',
    },
    zIndex: 1,

    [`&.${actionButtonClasses.fixedInMobile}`]: {
      position: { xs: 'fixed', lg: 'static' },
    },

    [`&.${actionButtonClasses.bordered}`]: {
      bgcolor: 'background.default',
      borderColor: 'border.primary',
      borderWidth: { xs: '1px', lg: 0 },
      borderStyle: { xs: 'solid', lg: 'none' },
    },

    [`&.${actionButtonClasses.topBordered}`]: {
      bgcolor: 'background.default',
      borderColor: 'border.primary',
      borderTopWidth: { xs: '1px', lg: 0 },
      borderTopStyle: { xs: 'solid', lg: 'none' },
    },
  },
  button: {
    minWidth: { xs: 'auto', sm: 400, lg: 'auto' },
    py: {
      xs: 1.25,
      lg: 2,
    },
  },
  buttonLarge: {
    width: { lg: '50%' },
    py: {
      xs: 1.25,
      lg: 1.5,
    },
  },
  buttonSecondary: {
    py: {
      xs: 0,
      lg: 2,
    },
  },
}
